import React from 'react';
import {telemetrySendEvent} from '@packages/systems/designer/canvas';

/**
 * Hooks that allows us to observe what data from the required has arrived to Canvas App
 * This reporting is used to debugging cases when users are reporting blank screen on accessing Canvas app
 */
export const useReportReceivedRequiredProjectData = (
  data: Record<string, any>,
  position: string
) => {
  const allDataArrivalReported = React.useRef(false);

  React.useEffect(() => {
    const values = Object.values(data);
    const keys = Object.keys(data);
    // send event if the values under all keys haven't been received yet
    if (values.every((value) => value === undefined)) {
      telemetrySendEvent({
        name: `no required data received in ${position}`,
        data: {
          value: keys.join(', '),
        },
      });

      // send event if some of the values under all keys haven't been received yet
    } else if (values.some((value) => value === undefined)) {
      telemetrySendEvent({
        name: `some required data not received in ${position}`,
        data: {
          value: keys.filter((key) => data[key] === undefined).join(', '),
        },
      });

      // send event if all the values under all keys have been received
    } else if (values.every((value) => value !== undefined)) {
      if (!allDataArrivalReported.current) {
        allDataArrivalReported.current = true;
        telemetrySendEvent({
          name: `all required data received in ${position}`,
          data: {
            value: keys.join(', '),
          },
        });
      }
    }
  }, [...Object.values(data)]);
};
